// Texty modalu „Možnosti doručení" na detailu produktu (shippingModal.js).
export default {
  title: 'Možnosti doručení',
  sub: 'Ceny a termíny pro tento produkt',
  close: 'Zavřít',
  done: 'Rozumím',
  terms: 'Doprava a platba',
  deliver: 'Doručíme',
  pickupEta: 'Vyzvednete',
  ship: 'Odešleme',
  /** pás expedice v den expedice; `cutoff` = dnešní uzávěrka („14:30") */
  orderToday: (cutoff) => 'Objednáte-li dnes do ' + cutoff + ', odešleme ještě dnes',
  countdown: 'do expedice zbývá',
  /** dovětek pásu expedice „· s PPL už zítra 6. 9." */
  fastShip: 'už',
  loading: 'Načítáme možnosti doručení…',
  error: 'Možnosti doručení se teď nepodařilo načíst.',
  /** štítek metody v akci na dopravu (#322): „Akce do 25. 10." */
  promoTag: (until) => 'Akce do ' + until,
};
